<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="image" src="images/f0001-01.jpg"/></p>
<p class="image"><a id="page_2"><img alt="image" src="images/f0002-01.jpg"/></a></p><a id="page_2">
</a><h1 class="h1"><a id="page_2"></a><a id="page_3"></a><a id="title">Sticky, Chewy, Messy, Gooey</a></h1><a id="title">
<p class="subtitle"><strong>DESSERTS FOR THE SERIOUS SWEET TOOTH</strong></p>
<p class="author"><strong>By Jill O’Connor</strong></p>
<p class="author"><span class="small"><strong>PHOTOGRAPHS BY LEIGH BEISCH</strong></span></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00a_title.vue?221781ec